<div class="container-fluid">
    <div>
      <app-users-header (searchByName)="searchUsersByName($event)" 
                        [tableSettings]="tableSetting.columns"
                        (resetFilters)="resetFilters($event)">
      </app-users-header>    
    </div>
    <hr>
    <div class="mt-2">
    <table class="table">
      <thead>
        <tr>
          <td class="w-20" *ngFor="let column of tableSetting.columns;let i = index">
            <div *ngIf="column.isSortable">
              
              <span class="columheader" style="cursor:pointer">{{column.title}}</span>                   
              <span class="icon-ic_filtered column-filter-icon cursor-pointer"  (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>
                        
            </div>
            <div *ngIf="column.isFilterIcon">
                <!--  -->
                <span (click)="showSortingPopup(column)">
                    <span [ngClass] = "{'isActive' : column.isSelected }"  class="columheader" style="cursor:pointer">{{column.title}}</span>            
                    <span class="icon-ic_filtered column-filter-icon cursor-pointer"></span>
                </span>  
                <!-- <span class="icon-ic_sorted-1 column-filter-icon cursor-pointer"
                *ngIf="!isSortedDecending && column.isSortable" (click)="isSortedDecending = true; sordbyStatus('Asc')">
              </span>
  
              <span class="icon-ic_sorted-2 column-filter-icon cursor-pointer"
                *ngIf="isSortedDecending && column.isSortable" (click)="isSortedDecending = false ; sordbyStatus('Desc')">
              </span>           -->
            </div>
            <div *ngIf="column.isStaticColumn">
              <span class="columheader">{{column.title}}</span>
            </div>         
            <div class="resource-dropdown" *ngIf="column.displaysort">
              <app-users-filter [roleArray]="roleArray" 
                                [cityArray]="cityArray" 
                                [officeArray]="officeArray"
                                [statusArray]="statusArray"
                                [column]="column" 
                                [tableSettings]="tableSetting"
                                (gridFiltersApplied)="checkFilterApplied($event)">
              </app-users-filter>
            </div>
          </td>
        </tr>
      </thead>
      <tbody class="results-list-panel" (click)="hideDropdowns()">
        <div class="no-search-results" *ngIf="((usersList!=null)&&(usersList.length==0))">
          <span class="icon-ic_Search_NEG_circle"></span>
          <label>No results found</label>
        </div>
  
        <!--<tr
        *ngFor="let user of usersList ;let i = index"> -->
          <tr *ngFor="let d of usersList | paginate: { itemsPerPage: 10, currentPage: p, totalItems: totalCount};let i = index">                 
                    
          
          <td>
            <span class="showellipsis" tooltip={{d.firstName}}>{{d.firstName}} {{d.lastName}}</span>
          </td>
          <td>
            <span class="showellipsis" tooltip="{{d.email}}">{{d.emailId}}</span>
          </td>
          <td>
            <span class="showellipsis" tooltip="{{d.appRoleName}}">{{d.appRoleName}}</span>
          </td>
          <!-- <td>
            <span class="showellipsis" tooltip={{user.phone}}>{{user.phone}}</span>
          </td> -->
          <!-- <td>
            <span *ngIf="d.cityData > 1"> <i class="icon-ic_info float-left mt-1 mr-2" style="padding-top: 5px;" (click)="popuptemplatesCity(popuptemplateCity,d.appUserId,d.name)" style="cursor: pointer;" ></i></span>
            <span class="showellipsis" tooltip={{d.cityName}}>{{d.cityName}}</span>
          </td> -->
          <!-- <td>
              <span *ngIf="d.officeData > 1"> <i class="icon-ic_info float-left mt-1 mr-2" style="padding-top: 5px;" (click)="popuptemplates(popuptemplate,d.appUserId,d.name)" style="cursor: pointer;" ></i></span>
            <span class="showellipsis" tooltip={{d.officeName}}>{{d.officeName}}</span>
          </td>  -->
         <td>
            <span class="showellipsis"
                  [tooltip]="d.cityNamesArray ? d.cityNamesArray.join(', ') : d.cityName">
              {{ d.cityNamesArray ? d.cityNamesArray.slice(0, 2).join(', ') : d.cityName }}
              <span *ngIf="d.cityNamesArray && d.cityNamesArray.length > 2">...</span>
            </span>
          </td>
          <td>
            <span class="showellipsis"
                  [tooltip]="d.officeNamesArray ? d.officeNamesArray.join(', ') : d.officeName">
              {{ d.officeNamesArray ? d.officeNamesArray.slice(0, 2).join(', ') : d.officeName }}
              <span *ngIf="d.officeNamesArray && d.officeNamesArray.length > 2">...</span>
            </span>
          </td>
          <td>
            <span class="circle" [ngClass]="{'bg-red': !d.isActive,'bg-green': d.isActive}"></span>
                        <span class="showellipsis">{{d.isActive ? 'Active' : 'Inactive'}}</span>
          </td>
          <!-- <td>
            <span *ngIf="d.officeData > 1"> <i class="icon-ic_info float-left mt-1 mr-2" style="padding-top: 5px;" (click)="popuptemplates(popuptemplate,d.appUserId,d.name)" style="cursor: pointer;" ></i></span>
          <span class="showellipsis" tooltip={{d.isRequestor}}>{{d.isRequestor}}</span>
        </td> 
        <td>
          <span *ngIf="d.officeData > 1"> <i class="icon-ic_info float-left mt-1 mr-2" style="padding-top: 5px;" (click)="popuptemplates(popuptemplate,d.appUserId,d.name)" style="cursor: pointer;" ></i></span>
        <span class="showellipsis" tooltip={{d.isApprover}}>{{d.isApprover}}</span>
          </td> -->

        <!-- <td>
            <span class="showellipsis" tooltip={{d.dateAdded}}>{{d.dateAdded}}</span>                  
        </td>
        <td>
            <span class="showellipsis" tooltip={{d.addedBy}}>{{d.addedBy}}</span>                  
        </td> -->
  
          <td class="d-flex justify-content-end">
            <i class="icon-ic_edit px-2" style="cursor: pointer;" (click)="editUser(d.appUserID)"></i>
            <i class="icon-ic_delete px-2" style="cursor: pointer;" (click)="deleteUser(d.appUserID,d)"></i> 
            <i class="icon-ic_info" style="cursor: pointer;" (click)="openUserDetails(d)"></i>
          </td>
  
          
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #popuptemplate>
      <div class="modal-header"> 
        <h4>Work location details of {{displayUserName}}</h4>
          <i class="icon-ic_delete mt-1" (click)="modalclose(popuptemplate)"></i>
        </div>
        <div class="modal-body" style="padding: 10px;">
            <div class="col-md-12">
              <div *ngFor="let office of officeName"class="row" style="margin-bottom: 5px;"> 
                <span>{{office}}</span>
              </div>
        </div> 
        </div> 
   </ng-template>  
   <ng-template #popuptemplateCity>
    <div class="modal-header"> 
      <h4>City details of {{displayUserName}}</h4>
        <i class="icon-ic_delete mt-1" (click)="modalclose(popuptemplateCity)"></i>
      </div>
      <div class="modal-body" style="padding: 10px;">
          <div class="col-md-12">
            <div *ngFor="let city of cityName"class="row" style="margin-bottom: 5px;"> 
              <span>{{city}}</span>
            </div>
      </div> 
      </div> 
  </ng-template>  <!-- May be drop down have to check  -->
   
    <div class="paginationwithcount" *ngIf="((usersList!=null)&&(usersList.length>0))" (click)="hideDropdowns()"> 
      <span class="mx-4 mb-4">Page</span>
      <pagination [(ngModel)]="filterData.page" 
                  [boundaryLinks]="true"
                  (pageChanged)="changeCurrentPage($event);p = $event" 
                  [(totalItems)]="totalCount" 
                  [maxSize]="5" 
                  firstText="&shy;"
                  lastText="&shy;" 
                  previousText="&shy;" 
                  nextText="&shy;" 
                  [rotate]="false" 
                  [itemsPerPage]="itemsperPage">
      </pagination>
    </div>
     <div class="totalcount" *ngIf="((usersList!=null)&&(usersList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span>
    </div>
  </div>
